import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories, categoryMap } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { useEffect } from 'react';

const CategoryPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? categoryMap[slug] : undefined;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as const });
  }, [slug]);

  const filteredArticles = slug
    ? articles.filter((a) => a.category === slug)
    : articles;

  const categoryName = category?.name || '全部分类';

  const structuredData = category
    ? {
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'CollectionPage',
            name: `${category.name} - 深度解析`,
            url: `https://www.example.com/category/${category.slug}`,
            description: category.description,
            isPartOf: { '@type': 'WebSite', name: '深度解析', url: 'https://www.example.com/' },
          },
        ],
      }
    : null;

  return (
    <>
      {structuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      )}

      <Navbar />

      <main className="pt-20">
        <div className="w-full px-4 md:px-6 lg:px-8 py-8 bg-background-50">
          <div className="max-w-6xl mx-auto">
            <Breadcrumb
              items={[
                { label: categoryName },
              ]}
            />

            <div className="mt-6 mb-8">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                {categoryName}
              </h1>
              {category && (
                <p className="text-sm text-foreground-600 mt-2 max-w-2xl">
                  {category.description}
                </p>
              )}
            </div>

            {/* Category Tabs */}
            <div className="flex flex-wrap gap-2 mb-8">
              <Link
                to="/category/xianxiang-jiexi"
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  slug === 'xianxiang-jiexi' || !slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                全部
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                    slug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredArticles.length === 0 ? (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {filteredArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))}
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
};

export default CategoryPage;